import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactHero from '../components/contact/ContactHero';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';
import SEO from '../components/SEO';
import {
  organization,
  localBusiness,
  breadcrumb,
  wrap,
  SITE_URL,
} from '../components/seo/schemas';
import { Toaster } from '../components/ui/toaster';

const PAGE_URL = `${SITE_URL}/contact`;

const structuredData = wrap([
  organization,
  localBusiness,
  breadcrumb([
    { name: 'Home', url: SITE_URL },
    { name: 'Contact', url: PAGE_URL },
  ]),
  {
    '@type': 'ContactPage',
    '@id': `${PAGE_URL}#contactpage`,
    url: PAGE_URL,
    name: 'Contact Upscale — Book a free growth session',
    description:
      'Get in touch with Upscale Growth AS. Book a free 30-minute growth strategy session. Based at Rådhusgata 9, Oslo, Norway.',
    inLanguage: 'en',
    mainEntity: { '@id': `${SITE_URL}/#localbusiness` },
  },
]);

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Contact Upscale | Free Growth Strategy Session - Oslo Marketing Agency"
        description="Book a free 30-minute growth strategy session with Upscale. Get expert advice on startup marketing, user acquisition, and scaling strategies. Located in Oslo, Norway at Rådhusgata 9."
        keywords="contact growth marketing agency, free marketing consultation Oslo, startup advisor Norway, marketing strategy session, Rådhusgata Oslo, book growth session"
        canonicalUrl={PAGE_URL}
        ogTitle="Book a free growth session with Upscale"
        ogDescription="30-minute strategy session with our growth advisor. Oslo-based. We help startups gain traction and scale."
        structuredData={structuredData}
      />
      <Navbar />
      <ContactHero />
      <div className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>
      <Footer />
      <Toaster />
    </div>
  );
};

export default ContactPage;
